/**
 * @description Pack SO onboarding host — first-run + Add company (LYN-360, LYN-361)
 *
 * @dependencies OnboardingModal, PackChromeContext, AuthContext, CompanyContext
 *
 * @notes Same 356 modal + writer. Welcome → Begin → step 1 → step 2.
 *   Zero companies: Welcome to {platformName}. Dropdown: Add company.
 */

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useCompany } from '../../../contexts/CompanyContext';
import { usePackChrome } from '../../../contexts/PackChromeContext';
import OnboardingModal from '../../onboarding/OnboardingModal';

export default function PackOnboardingHost() {
  const { towtechSoChrome, addCompanyOpen, closeAddCompany } = usePackChrome();
  const { companies, switchCompany } = useAuth();
  const { hasCompany } = useCompany();
  const navigate = useNavigate();
  const grantedCount = companies?.length || 0;

  if (!towtechSoChrome) {
    return null;
  }

  if (grantedCount === 0 && !hasCompany) {
    return (
      <OnboardingModal
        isOpen
        packSurface
        firstRun
        onClose={async (createdId) => {
          if (createdId) {
            await switchCompany(createdId);
          }
          navigate('/so/company', { replace: true });
        }}
      />
    );
  }

  return (
    <OnboardingModal
      isOpen={addCompanyOpen}
      packSurface
      packTitle="Add company"
      allowDismiss
      onClose={async (createdId) => {
        closeAddCompany();
        if (createdId) {
          await switchCompany(createdId);
        }
      }}
    />
  );
}
